/* eslint-disable no-unused-vars */
import React from "react";
import {
  Navbar,
  Nav,
  NavDropdown,
  Col,
  Row,
  Dropdown,
  NavLink
} from "react-bootstrap";
import "./header.scss";
import "../../assets/styles/main.scss";
import {
  logo,
  pipeIcon,
  logoutIcon,
  logoutIcon2,
  menuIcon,
  filterIcon
} from "./header-icons";

class Navigation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selections: {}
    };
    this.ws = this.props.ws;
  }
  getSelections = async () => {
    await this.ws.connect("getSelections").then(response => {
      this.setState({
        selections: response.data.selections
      });
    });
    this.props.handler();
  };

  setSelection = async select => {
    console.log(select, "1");
    await this.ws.connect("setSelections", select);
    await this.getSelections();
    this.props.handler();
  };

  clearSelection = async () => {
    await this.ws.connect("clearSelections");
    await this.getSelections();
    this.props.handler();
  };

  async componentDidMount() {
    await this.ws.connect("clearSelections");
    await this.getSelections();
  }
  logout = e => {
    e.preventDefault();
    localStorage.removeItem("user");
  };

  render() {
    let years,
      categoryItems,
      yearItems,
      monthItems,
      productItems,
      branchItems,
      clientItems;

    return (
      <header id="navigation">
        <Navbar collapseOnSelect expand="lg" className="bg-blue align-items-center justify-content-between py-1" variant="dark">
          <Navbar.Brand className="mr-0 pl-3 p-0" href="">{ logo }</Navbar.Brand>
        </Navbar>
      </header>
    );
  }
}
const UpdateBar = () => {
  return (
    <div
      className="update-bar mb-4 d-flex align-items-center justify-content-start justify-content-sm-end px-3"
      id="update-bar"
    >
      <div className="text-primary d-flex d-sm-block flex-column">
        <span className="is-font-weight--medium">Última vez actualizado:</span> <span className="ml-0 ml-sm-2 is-font-weight--bold">4 de Enero del 2020 8:40 AM</span>
      </div>
    </div>
  );
};

export { UpdateBar, Navigation };
